import React, { ReactElement } from 'react'
import Image from '../../../../BaseComponents/Image'
import InformationRowItem from '../RowItem/InformationRowItem'

type Props = {
    altText?: string
    imageUrl: string
    isFlag?: boolean
}
const CompetitorImage = ({ altText, imageUrl, isFlag = false }: Props): ReactElement => {
    const aspectRatio = isFlag ? '3:2' : 'ORIGINAL'
    return (
        <InformationRowItem width={20}>
            <Image
                width={20}
                size="L"
                aspectRatio={aspectRatio}
                imageUrl={imageUrl}
                alt={altText}
            />
        </InformationRowItem>
    )
}
export default CompetitorImage
